"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var base_1 = require("./base");
var XbedGatewayClient = /** @class */ (function (_super) {
    __extends(XbedGatewayClient, _super);
    function XbedGatewayClient(debug, gatewayConfig, interceptor) {
        if (debug === void 0) { debug = true; }
        var _this = this;
        var defaultReqInterceptor = function (req) {
            if (interceptor && interceptor.request) {
                return interceptor.request(req);
            }
            return req;
        };
        var defaultRespInterceptor = function (resp) {
            var payload = {};
            // 过滤掉一层data
            if (resp.data.retCode === _this.successCode) {
                resp.data.data ? (payload = resp.data.data) : (payload = {});
                resp.data = payload;
            }
            if (interceptor && interceptor.response) {
                return interceptor.response(resp);
            }
            return resp;
        };
        _this = _super.call(this, debug, defaultReqInterceptor, defaultRespInterceptor) || this;
        _this.gatewayUrl = gatewayConfig.gatewayUrl;
        _this.edition = gatewayConfig.edition;
        _this.goods = gatewayConfig.goods;
        _this.terrace = gatewayConfig.terrace;
        _this.xbedSecretKey = gatewayConfig.xbedSecretKey;
        _this.xbedSecretToken = gatewayConfig.xbedSecretToken;
        _this.token = '';
        return _this;
    }
    XbedGatewayClient.prototype.setToken = function (token) {
        this.token = token;
    };
    XbedGatewayClient.prototype.removeToken = function () {
        this.token = '';
    };
    XbedGatewayClient.prototype.prepareRequest = function (url, reqData, method, token, params, header) {
        if (token === void 0) { token = ''; }
        /**
         * 如果是get 和 put，用url params生成Sign，如果是post则用reqData生成Sign
         * @param httpMethod Http 请求方法
         */
        var signWithReqData = function (httpMethod) {
            if (httpMethod === 'get' ||
                httpMethod === 'put' ||
                httpMethod === 'delete') {
                return false;
            }
            return true;
        };
        if (!header) {
            header = {
                Edition: this.edition,
                Goods: this.goods,
                Terrace: this.terrace
            };
        }
        if (/elong/.test(url)) {
            header['Content-Type'] = 'application/json';
        }
        // 生成secretKey
        var secretKey = this.secret.getGatewayAPISecretKey(header.Goods, header.Terrace, header.Edition, token);
        header.Pencil = this.secret.getSign(signWithReqData(method) ? reqData : params, secretKey);
        header.secret = secretKey;
        header.Right = token;
        return this.fetch(url, header, method, reqData, true, params);
    };
    ////////////////////////// API //////////////////////////
    /**
     * 用户登录接口
     * @param phone 手机号码
     * @param password 验证码
     * @param source 来源，0-微信公众号，2-IOS，3-Android，4-微信小程序
     * @param openId 微信公众号ID
     */
    XbedGatewayClient.prototype.login = function (params) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/user/v2/login", params);
    };
    /**
     * 验证用户登录接口
     * @param source 来源，0-微信公众号，2-IOS，3-Android，4-微信小程序
     * @param openId 微信公众号ID
     */
    XbedGatewayClient.prototype.openIdLogin = function (openId, source) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/user/login/byOpenId", { openId: openId, source: source });
    };
    /**
     * 用户退出接口V2
     * @param source 渠道来源：0 - 微信公众号；1 - 去呼呼；2 - IOS；3 - Android；4 - OMS；5 - 携程；6 - 业主会；7 - 美团；8 - XBED；10 - 办理入住时系统注册；11 - 活动注册；12 - 预订时系统注册；14 - OTA；15 - wap；16 - www；17 - 长租
     * @param openId 微信openId
     */
    XbedGatewayClient.prototype.logout = function (source, openId, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/user/v2/logout", {
            source: source,
            openId: openId
        }, token);
    };
    /**
     * 获取验证码接口
     * @param isText true普通验证码，false语音验证码
     * @param phone 手机号码
     * @param imgCode 用户输入的图片验证码
     * @param verifyCode 验证码标识
     */
    XbedGatewayClient.prototype.getVerificationCode = function (params) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/user/getVerificationCode", params);
    };
    /**
     * 查询用户收藏门店
     * @param page 当前页数
     * @param size 每页数量
     * @param token
     */
    XbedGatewayClient.prototype.getUserCollectChain = function (page, size, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/user/getUserCollectChain", { page: page, size: size }, token);
    };
    /**
     * 添加/删除用户门店收藏夹
     * @param chainId 门店id
     * @param type 1-添加收藏夹；2-删除收藏夹
     * @param token
     */
    XbedGatewayClient.prototype.collectChain = function (chainId, type, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/user/collectChain", { chainId: chainId, type: type }, token);
    };
    /**
     * 房价日历
     * @param roomTypeId 	房型ID
     * @param token
     */
    XbedGatewayClient.prototype.getRoomPriceCalendar = function (roomTypeId) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/xbedChannelHotel/getRoomPriceCalendar", { roomTypeId: roomTypeId });
    };
    /**
     * 房型详情页
     * @param startDate 入住日期
     * @param endDate 退房日期
     * @param roomTypeId 房型Id
     * @param token
     */
    XbedGatewayClient.prototype.getRoomTypeInfo = function (startDate, endDate, roomTypeId) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/xbedChannelHotel/v4/getRoomTypeInfo", { startDate: startDate, endDate: endDate, roomTypeId: roomTypeId });
    };
    /**
     * 房型预订页
     * @param startDate 入住日期
     * @param endDate 退房日期
     * @param roomTypeId 房型Id
     * @param token
     */
    XbedGatewayClient.prototype.getRoomBooking = function (startDate, endDate, roomTypeId) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/xbedChannelHotel/getRoomBooking", { startDate: startDate, endDate: endDate, roomTypeId: roomTypeId });
    };
    /**
     * 查询剩余房量
     * @param startDate 入住日期
     * @param endDate 退房日期
     * @param roomTypeId 房型Id
     * @param token
     */
    XbedGatewayClient.prototype.getRoomCount = function (startDate, endDate, roomTypeId) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/xbedChannelHotel/getRoomCount", { startDate: startDate, endDate: endDate, roomTypeId: roomTypeId });
    };
    /**
     * 计算房间价格
     * @param roomTypeId 房型Id
     * @param startDate 入住日期
     * @param endDate 退房日期
     * @param roomCount 房间数量
     * @param token
     * @param isOpen  是否为企业用户
     * @param mobile  用户电话
     *
     */
    XbedGatewayClient.prototype.getTotalPrice = function (roomTypeId, startDate, endDate, roomCount, isOpen, mobile) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/xbedChannelHotel/getTotalPrice", { roomTypeId: roomTypeId, startDate: startDate, endDate: endDate, roomCount: roomCount, isOpen: isOpen, mobile: mobile });
    };
    /**
     * 查询订单列表V2(增加房型打包后需要更新的订单列表接口)
     * @param type 0：全部 1：待支付 2：待入住 3：已入住 4：待评价
     * @param page
     * @param size
     * @param token
     */
    XbedGatewayClient.prototype.checkinList = function (type, page, size, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/order/checkinList", {}, token, 'get', { type: type, page: page, size: size });
    };
    /**
     * 查询订单列表(增加艺龙接口数据)
     * @param status 0：全部 1：待支付 2：待入住 3：已入住 4：待评价 订单状态（必填）
     * @param page_num 页码大小（必填）
     * @param page_size 页码大小（必填）
     * @param user_id 用户id（必填）
     */
    XbedGatewayClient.prototype.orderList = function (param, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/v1/elong/hotel-order-list", param, token, 'post', param);
    };
    /**
     * 查询收藏接口
     * @param page 当前页(必填)
     * @param page_size 	每页数据条数(必填)
     * @param user_id 	用户id(必填)
     */
    XbedGatewayClient.prototype.getCollectList = function (page, pageSize, userId, token) {
        return this.xbedClientPrepareRequest(this
            .gatewayUrl + "api/v1/elong/collect/list/" + userId + "/" + page + "/" + pageSize, {}, token, 'get', { page: page, pageSize: pageSize, userId: userId });
    };
    /**
     * addElongCollect 增加艺龙收藏
     * @param city_name 城市名（必填）	string
     * @param district_name 区县名（也建议填上）	string
     * @param hotel_id 酒店id（必填）	string
     * @param hotel_name 酒店名称（必填）	string
     * @param image_url 酒店首页图片url（必填）	string
     * @param low_rate 最低价格（也建议填上）	number
     * @param user_Id 用户id（必填）	number
     */
    XbedGatewayClient.prototype.addElongCollect = function (param, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/v1/elong/collect/add", __assign({}, param), token);
    };
    /**
     * deleteCollect 删除艺龙收藏
     * @param hotel_id 酒店id（必填）	string
     * @param user_Id 用户id（必填）	string
     */
    XbedGatewayClient.prototype.deleteCollect = function (hotelId, userId, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/v1/elong/collect/delete/" + userId + "/" + hotelId, {}, token, 'delete', { hotelId: hotelId, userId: userId });
    };
    /**
     * getAllCit 获取所有城市
     */
    XbedGatewayClient.prototype.getAllCit = function () {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/v1/elong/geo/city/list", {}, '', 'get', {});
    };
    /**
     * 高德api的adcode（国家标准code）转艺龙城市code
     * @param adcode	高德api的adcode（国家标准code）	string
     */
    XbedGatewayClient.prototype.getCityCode = function (adcode) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/v1/elong/geo/city-info/get-code/" + adcode, {}, '', 'get', {});
    };
    /**
     * 查询订单列表（口令）V2
     * @param command 口令
     * @param commandName 口令姓名
     * @param commandPhone 口令手机
     * @param token
     */
    XbedGatewayClient.prototype.commandCheckinList = function (command, commandName, commandPhone, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/command/checkinList", {}, token, 'get', { command: command, commandName: commandName, commandPhone: commandPhone });
    };
    /**
     * 门店评论列表
     * @param page 页数
     * @param pageSize 每页数量
     * @param roomTypeId 房型Id
     * @param token
     */
    XbedGatewayClient.prototype.getRatingList = function (page, pageSize, roomTypeId) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/xbedChannelHotel/v4/getRatingList", { page: page, pageSize: pageSize, roomTypeId: roomTypeId });
    };
    /**
     * 取指定房间的评论V4
     * @param page
     * @param pageSize
     * @param roomId
     */
    XbedGatewayClient.prototype.roomComment = function (page, size, roomId) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/v4/room/comment", {
            page: page,
            size: size,
            roomId: roomId
        });
    };
    /**
     * 门店列表
     * @param bedCount 床数 (-1代表更多，不传代表不限,不限床数时，不用传该字段
     * @param bedroomNum 卧室数量 (-1代表更多，不传代表不限,不限床数时，不用传该字段)
     * @param city 城市（必传）
     * @param flag 是否需要加载搜索元素(必传)，0 不需要 1 需要
     * @param startDate 入住日期 yyyy-MM-dd
     * @param endDate 离店日期 yyyy-MM-dd
     * @param indiviTag 特色 (可多选)
     * @param isAvailableOnly 只看有房，默认0 （0 否，1是）*****如果这里是1 则前端隐藏isFull=1的门店
     * @param maxPrice 	价格最大值，单位分
     * @param minPrice 价格最小值，单位分
     * @param orderBy 默认排序，不用传该字段 (0价格从低到高；1价格从高到低)
     * @param page 页码
     * @param pageSize 每页记录数
     * @param position 位置
     * @param token
     */
    XbedGatewayClient.prototype.getXbedChannelHotelList = function (params) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/xbedChannelHotel/v2/getChannelHotelList", params);
    };
    /**
     * 门店详情页
     * @param channelHotelId 门店id
     * @param startDate 入住时间
     * @param endDate 退房时间
     * @param token
     */
    XbedGatewayClient.prototype.getXbedChannelHotelInfo = function (channelHotelId, startDate, endDate, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/xbedChannelHotel/getChannelHotelInfo", { channelHotelId: channelHotelId, startDate: startDate, endDate: endDate }, token);
    };
    /**
     * 打包房型-支付接口
     * @param arrivalTime 到达时间
     * @param beginDate 入住日期
     * @param endDate 离店日期
     * @param custName 客户姓名
     * @param orderPrice 订单总价（单位：分）
     * @param roomNum 房间数量
     * @param roomPrice 房费（单位：分）
     * @param roomTypeId 房型ID
     * @param totalPrice 应付金额 (单位：分)
     * @param token
     */
    XbedGatewayClient.prototype.createChainOrder = function (params, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/ota/xbedChannelOrder/createOrder", params, token);
    };
    /**
     * 个人中心首页
     *
     */
    XbedGatewayClient.prototype.getHomePageInfo = function () {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/personal/getHomePageInfo", {});
    };
    /**
     * 新增用户反馈
     *
     *  @param checkinId 订单号。非必传
     *  @param content 反馈内容
     */
    XbedGatewayClient.prototype.addFeedback = function (params, token) {
        if (token === void 0) { token = ''; }
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/addFeedback", params, token);
    };
    /**
     * 首页接口
     *
     */
    XbedGatewayClient.prototype.getHomePage = function () {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/app/getHomePage", {});
    };
    /**
     * 上传client_id
     *
     *  @param clientId 客户端ID
     */
    XbedGatewayClient.prototype.clientId = function (clientId, token) {
        if (token === void 0) { token = ''; }
        return this.xbedClientGetRequest(this.gatewayUrl + "api/user/clientId", { clientId: clientId }, token);
    };
    /**
     * 是否可以人脸识别
     *
     */
    XbedGatewayClient.prototype.canVerify = function (token) {
        if (token === void 0) { token = ''; }
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/v4/canVerify", {}, token);
    };
    /**
     * 人脸识别验证（新微信端）
     *
     *  @param name
     *  @param phone
     *  @param mediaId
     *  @param userId 非必传
     *  @param idNo
     */
    XbedGatewayClient.prototype.faceRecog = function (name, phone, mediaId, userId, idNo, token) {
        if (token === void 0) { token = ''; }
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/faceRecog", { name: name, phone: phone, mediaId: mediaId, userId: userId, idNo: idNo }, token);
    };
    /**
     * APP-UI设置参数接口
     *
     */
    XbedGatewayClient.prototype.getAppUISetting = function () {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/app/getAppUISetting", {});
    };
    /**
     * 识别身份证以验证身份
     *
     *  @param frontImg 正面照片
     *  @param type 类型。1-微信；2-APP
     *  @param backImg 背面照片
     */
    XbedGatewayClient.prototype.ocrIDCard = function (frontImg, type, backImg, token) {
        if (token === void 0) { token = ''; }
        return this.xbedClientPostRequest(this.gatewayUrl + "api/ocrIDCard", { frontImg: frontImg, type: type, backImg: backImg }, token);
    };
    /**
     * 查询首页元素（推荐选项卡）V4
     */
    XbedGatewayClient.prototype.recommend = function (token) {
        if (token === void 0) { token = ''; }
        return this.xbedClientGetRequest(this.gatewayUrl + "api/app/getHomePage/v4/recommend", {}, token);
    };
    /**
     * 获取Xbed的当前时间
     */
    XbedGatewayClient.prototype.xbedCurrTime = function () {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/app/xbedCurrTime", {});
    };
    /**
     * 可销售房间具体信息列表V4
     *
     * @param longitude 经度
     * @param rentType 租赁类型。默认值是3，长租和短租
     * @param isImmediateCheckin 是否即时入住。非必传，默认false
     * @param chainId 门店id
     * @param isAvailableOnly 只看有房，默认0 （0 否，1是）
     * @param bedroomNum 卧室数量。-1代表更多，不传代表不限
     * @param size 每页记录数
     * @param bedCount 床数。-1代表更多，不传代表不限
     * @param tradingArea 商圈的code
     * @param start 页码
     * @param endDate 离店日期 yyyy-MM-dd
     * @param maxPrice 价格最大值，单位分
     * @param latitude 纬度
     * @param startDate 入住日期 yyyy-MM-dd
     * @param district 区县的code
     * @param minPrice 价格最小值，单位分
     * @param city 城市名。必传
     * @param indiviTag 特色
     * @param orderBy 默认排序
     */
    XbedGatewayClient.prototype.searchRoomList = function (params, token) {
        if (token === void 0) { token = ''; }
        return this.xbedClientGetRequest(this.gatewayUrl + "api/room/v4/searchRoomList", params, token);
    };
    /**
     * 根据城市查询房间标签
     * @param city 城市（中文）
     */
    XbedGatewayClient.prototype.queryRoomTag = function (city) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/room/v4/queryRoomTag", { city: city });
    };
    /**
     * 获取热门城市
     * @param num 热门城市数量
     * @param showPic 是否显示热门城市图片
     */
    XbedGatewayClient.prototype.listFixHotCity = function (num, showPic) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/cityList/listFixHotCity", { num: num, showPic: showPic });
    };
    /**
     * 查询所有城市或有房间的城市
     * @param getAllCity
     */
    XbedGatewayClient.prototype.listAllCity = function (getAllCity) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/cityList/listAllCity", { getAllCity: getAllCity });
    };
    /**
     * 查询房间详情信息V4
     * @param roomId 房间ID
     */
    XbedGatewayClient.prototype.getRoomDetail = function (params) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/room/v4/getRoomDetail", params);
    };
    /**
     * 查询用户收藏房间V4
     * @param page
     * @param size
     * @param token
     */
    XbedGatewayClient.prototype.getCollectRooms = function (page, size, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/user/v4/getCollectRooms", { page: page, size: size }, token);
    };
    /**
     * 房间收藏变更
     * @param roomId 	房间ID
     * @param rentType 租赁类型 1 - 表示短租；2 - 表示长租
     * @param type 1-添加收藏房间；2-删除收藏房间
     * @param token
     */
    XbedGatewayClient.prototype.collectRoom = function (roomId, rentType, type, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/user/collectRoom", { roomId: roomId, rentType: rentType, type: type }, token);
    };
    /**
     * 查询首页元素（小住、长留、发现）V4
     * @param page
     * @param size
     * @param type 租赁类型。1-小住；2-长留；3-发现
     */
    XbedGatewayClient.prototype.recommendRoom = function (page, size, type, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/app/getHomePage/v4/recommendRoom", { page: page, size: size, type: type }, token);
    };
    /**
     * 判断能否续住
     * @param checkinId
     * @param token
     */
    XbedGatewayClient.prototype.verifyOverstay = function (checkinId, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/order/verifyOverstay", { checkinId: checkinId }, token);
    };
    /**
     * 通过openId刷新用户卡券userId的信息
     */
    XbedGatewayClient.prototype.refreshCardUserId = function (openId, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/couponCard/refreshCardUserId", { openId: openId }, token, 'put', { openId: openId });
    };
    /**
     * 查询3个月内的远期房态
     * @param roomId 房间ID
     */
    XbedGatewayClient.prototype.get3MonthRoomsStatus = function (roomId) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/room/get3MonthRoomsStatus", { roomId: roomId });
    };
    /**
     * 计算房间价格V2
     * @param activityId 指定执行活动id(不选择任何活动请传递 -1；首次访问不传递该字段)
     * @param beginDate 订单开始时间(isOverStay=1时传递，否则不传)
     * @param endDate 订单结束时间
     * @param cardCode 卡券code
     * @param checkinId 入住单Id(isOverStay=2时传递，否则不传)
     * @param flag flag=1时，会查询优惠券列表
     * @param isOverStay 1:订单,2:续住单
     * @param rentType 租房类型(1短租，2长租)
     * @param roomId 房间id
     * @param usedXdollar 用户用的xdollar
     */
    XbedGatewayClient.prototype.calculatePrice = function (params, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/v4/order/calculatePrice", params, token);
    };
    /**
     * 创建房间订单 (非续住)
     * @param activityId 指定执行活动id(如果不想选择活动就传递-1)
     * @param arrivalTime 预计到达时间
     * @param beginDate 订单开始时间
     * @param cardCode 使用卡券code(非必传参数)
     * @param command 口令
     * @param commandName 口令姓名
     * @param commandPhone 口令手机
     * @param endDate 订单结束时间
     * @param isPackage 是否为打包房型下单(1:是 0:否)
     * @param name 用户下单时填写的称呼
     * @param rentType 租房类型 1短租，2 长租
     * @param roomId 多个房间数组或逗号隔开
     * @param roomTypeId 打包房型id
     * @param xdollar Xdollar的数量(非必传参数)
     */
    XbedGatewayClient.prototype.createRoomOrder = function (params, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/order/createOrder/v2", params, token);
    };
    /**
     * 创建续住单
     * @param activityId 参加活动id 没有填写-1
     * @param beginDate 续住开始时间
     * @param endDate 续住结束时间
     * @param cardCode 卡券code（非必传）
     * @param checkinId checkinId
     * @param rentType 租房类型 1:短租 2:长租
     * @param xdollar xdollar的数量（非必传）
     * @param token
     */
    XbedGatewayClient.prototype.overStay = function (params, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/order/overStay/v2", params, token);
    };
    /**
     * 获取微信支付参数（微信）
     * @param body xbed-酒店 Xbed-长租在住清洁费 Xbed-短租押金
     * @param checkinId 入住单号
     * @param openId 用户标识(微信端必传)
     * @param orderNo 订单号
     * @param payFor 支付源（1 支付订单金额 2 长租清洁单 3 短租押金 4 打包房型）
     * @param price 价格
     * @param systemName 系统名称 丽家会：XbClean, 艾佰德：Xbed
     * @param token
     */
    XbedGatewayClient.prototype.getWecPayParam = function (params, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/order/getWecPayParam", params, token);
    };
    /**
     * 获取银联支付参数
     * @param checkinId 入住单号
     * @param orderNo 订单号
     * @param payFor 支付源（1 支付订单金额 2 长租清洁单 3 短租押金 4 打包房型）
     * @param price 价格
     * @param systemName 系统名称 丽家会：XbClean, 艾佰德：Xbed
     * @param token
     */
    XbedGatewayClient.prototype.unionWapPay = function (params, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/order/unionWapPay", params, token);
    };
    /**
     * 用户发票列表
     * @param page
     * @param size
     * @param token
     */
    XbedGatewayClient.prototype.findInvoiceList = function (page, size, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/invoice/findInvoiceList", { page: page, size: size }, token);
    };
    /**
     * 可开发票订单列表
     * @param page
     * @param size
     * @param token
     */
    XbedGatewayClient.prototype.canInvoiceOrderList = function (page, size, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/order/canInvoiceOrderList", { page: page, size: size }, token);
    };
    /**
     * 获取用户发票基础信息
     * @param token
     */
    XbedGatewayClient.prototype.invoiceInfo = function (token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/v2/invoice/info", {}, token);
    };
    /**
     * 保存发票
     * @param addressId 地址ID
     * @param orderNos 订单号
     * @param price 开票金额
     * @param token
     */
    XbedGatewayClient.prototype.saveInvoice = function (addressId, orderNos, price, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/invoice/saveInvoice", { addressId: addressId, orderNos: orderNos, price: price }, token);
    };
    /**
     * 保存电子发票
     * @param addressId 地址ID
     * @param orderNos 订单号
     * @param phone 手机号码
     * @param price 开票金额
     * @param token
     */
    XbedGatewayClient.prototype.saveElecInvoice = function (addressId, orderNos, phone, price, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/invoice/saveElecInvoice", { addressId: addressId, orderNos: orderNos, phone: phone, price: price }, token);
    };
    /**
     * 创建发票收件人
     * @param address 详细地址
     * @param city 市ID
     * @param code 邮编（可选）
     * @param county 地区ID
     * @param phone 收件人手机号码
     * @param province 省ID
     * @param realname 收件人真实姓名
     * @param taxpayerId 纳税人税号
     * @param title 发票抬头
     * @param titleType 1-个人；2-企业
     * @param token
     */
    XbedGatewayClient.prototype.invoiceAddReceiver = function (params, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/invoice/addReceiver", params, token);
    };
    /**
     * 修改发票收件人
     * @param address 详细地址
     * @param addressId 地址ID
     * @param city 市ID
     * @param code 邮编（可选）
     * @param county 地区ID
     * @param phone 收件人手机号码
     * @param province 省ID
     * @param realname 收件人真实姓名
     * @param taxpayerId 纳税人税号
     * @param title 发票抬头
     * @param titleType 1-个人；2-企业
     * @param token
     */
    XbedGatewayClient.prototype.invoiceUpdateReceiver = function (params, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/invoice/updateReceiver", params, token, 'put', params);
    };
    /**
     * 删除发票收件人
     * @param addressId 地址ID
     * @param token
     */
    XbedGatewayClient.prototype.invoiceDelReceiver = function (addressId, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/invoice/delReceiver", { addressId: addressId }, token, 'delete', { addressId: addressId });
    };
    /**
     * 创建电子发票地址
     * @param email 接收发票的邮箱
     * @param taxpayerId 纳税人识别号
     * @param title 发票抬头
     * @param titleType 1-个人；2-企业；
     * @param token
     */
    XbedGatewayClient.prototype.invoiceSaveElecInvoiceInfo = function (params, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/invoice/saveElecInvoiceInfo", params, token);
    };
    /**
     * 编辑电子发票地址
     * @param addressId 地址ID
     * @param email 接收发票的邮箱
     * @param taxpayerId 纳税人识别号
     * @param title 发票抬头
     * @param titleType 1-个人；2-企业；
     * @param token
     */
    XbedGatewayClient.prototype.invoiceEditElecInvoiceInfo = function (params, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/invoice/editElecInvoiceInfo", params, token, 'put', params);
    };
    /**
     * 删除电子发票地址
     * @param addressId 地址ID
     * @param token
     */
    XbedGatewayClient.prototype.invoiceDelElecInvoiceInfo = function (addressId, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/invoice/delElecInvoiceInfo", { addressId: addressId }, token, 'delete', { addressId: addressId });
    };
    /**
     * 分页查询文章列表
     * @param column 文章栏目(1集团动态，2媒体报道，3培训资料，4旅游攻略)
     * @param title 文章标题（模糊查询文章标题）
     */
    XbedGatewayClient.prototype.articleList = function (params) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/app/articleList", params);
    };
    /**
     * 微信js sdk 参数
     * @param url
     */
    XbedGatewayClient.prototype.jsapiTicket = function (url) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/wechat/jsapiTicket", { url: url });
    };
    /**
     * 地图模式展示楼宇V4
     * @param city 对应热门城市。必传
     * @param startDate 入住时间。yyyy-MM-dd
     * @param endDate 离店时间。yyyy-MM-dd
     * @param isAvailableOnly 只看有房，默认0 （0 否，1是）
     * @param isImmediateCheckin 	是否马上入住。true
     * @param rentType 租赁类型。1-短租；2-长租
     */
    XbedGatewayClient.prototype.getMapBuilding = function (params) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/v4/room/getMapBuilding", params);
    };
    /**
     * 查询用户入住信息
     * @param isPrivate 七牛是否是私有空间。1-是私有空间；0-不是
     * @param phone 入住人手机号
     * @param token
     */
    XbedGatewayClient.prototype.findCheckinPerson = function (isPrivate, phone, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/userInfo/findCheckinPerson", { isPrivate: isPrivate, phone: phone }, token);
    };
    /**
     * 查询卡券列表
     * @param token
     */
    XbedGatewayClient.prototype.getCouponCardList = function (token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/v4/couponCard/getCouponCardList", {}, token);
    };
    /**
     * 兑换优惠券
     * @param code 优惠码
     * @param token
     */
    XbedGatewayClient.prototype.getPreferentialCode = function (code, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/v4/activity/getPreferentialCode", { code: code }, token, 'put', { code: code });
    };
    /**
     * 获取活动列表
     * @param page 页码
     * @param size 每页记录条数
     * @param token
     */
    XbedGatewayClient.prototype.getActivityList = function (page, size, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/v4/activity/getActivityList", { page: page, size: size }, token);
    };
    /**
     * 获取活动列表v2
     * @param page 页码
     * @param size 每页记录条数
     * @param token
     */
    XbedGatewayClient.prototype.getActivityListV2 = function (page, size, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/v4/activity/getActivityListV2", { page: page, size: size }, token);
    };
    /**
     * 共享入住人——获取图片验证码
     */
    XbedGatewayClient.prototype.imageVerifyCode = function () {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/order/imageVerifyCode", {});
    };
    /**
     * 共享入住人——获取短信验证码
     * @param code 图片验证码
     * @param isText 是否短信验证码
     * @param phone 手机号码
     * @param verifyCode redis的key
     */
    XbedGatewayClient.prototype.messageVerifyCode = function (code, isText, phone, verifyCode) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/order/messageVerifyCode", { code: code, isText: isText, phone: phone, verifyCode: verifyCode });
    };
    /**
     * 共享入住人——获取共享订单信息
     * @param shareUUID
     */
    XbedGatewayClient.prototype.shareInfo = function (shareUUID) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/order/shareInfo/" + shareUUID, {});
    };
    /**
     * 共享入住人——共享订单添加入住人
     * @param operator 分享人的电话号码
     * @param checkinId 入住单号
     * @param imageVerifyCode 图片验证码
     * @param messageVerifyCode 短信验证码
     * @param phone 手机号码
     * @param shareKey 共享的信息的UUID
     * @param verifyCode redis的key
     */
    XbedGatewayClient.prototype.shareCheckin = function (operator, checkinId, imageVerifyCode, messageVerifyCode, phone, shareKey, verifyCode) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/order/shareCheckin", {
            operator: operator,
            checkinId: checkinId,
            imageVerifyCode: imageVerifyCode,
            messageVerifyCode: messageVerifyCode,
            phone: phone,
            shareKey: shareKey,
            verifyCode: verifyCode
        });
    };
    /**
     * 修改用户信息
     * @param params
     * @param token
     */
    XbedGatewayClient.prototype.updateUserInfo = function (params, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/user/updateUserInfo", params, token, 'put', params);
    };
    /**
     * 获取code的Url
     * @param url
     */
    XbedGatewayClient.prototype.getCodeUrl = function (url) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/wechat/getCodeUrl", { url: url });
    };
    /**
     * 获取openId
     * @param code
     */
    XbedGatewayClient.prototype.getOpenId = function (code) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/wechat/getOpenId", {
            code: code
        });
    };
    /**
     * 查询入住单详情(增加房型打包后需要更新的订单列表接口)
     * @description 只有isPackage=1（打包房型订单）并且type=1（待支付）的情况，才调用此接口
     * @param orderNo 订单号
     * @param token
     */
    XbedGatewayClient.prototype.checkinOrderInfoWithSpecialty = function (orderNo, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/order/package/checkinOrderInfo", { orderNo: orderNo }, token);
    };
    /**
     * 查询入住单详情V4
     * @description 实付金额在前台进行计算：实付金额 =（price-discount）
     * @param checkinId 入住单Id
     * @param token
     */
    XbedGatewayClient.prototype.checkinOrderInfoWithCommon = function (checkinId, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/order/v4/checkinOrderInfo", { checkinId: checkinId }, token);
    };
    /**
     * 获取待评论订单数据
     * @param page 页码
     * @param size 每页大小
     * @param token
     */
    XbedGatewayClient.prototype.waitEvaluate = function (page, size, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/order/waitEvaluate", { page: page, size: size }, token);
    };
    /**
     * 获取是否有待评论订单标识接口
     * @param token
     */
    XbedGatewayClient.prototype.waitEvaluateFlag = function (token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/order/waitEvaluateFlag", {}, token);
    };
    /**
     * 取消入住单
     * @param checkinId 入住单Id（非必传字段）
     * @param orderNo 订单号
     * @param token
     */
    XbedGatewayClient.prototype.cancelCheckinOrder = function (params, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/order/cancelCheckinOrder", params, token, 'put', params);
    };
    /**
     * 取消续住单
     * @param checkinInfoId 	子入住单id
     * @param token
     */
    XbedGatewayClient.prototype.cancelCheckinInfoOrder = function (checkinInfoId, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/order/cancelCheckinInfoOrder", { checkinInfoId: checkinInfoId }, token, 'put', { checkinInfoId: checkinInfoId });
    };
    /**
     * 办理退房
     * @param checkinId 入住单Id
     * @param roomId 房间Id
     * @param token
     */
    XbedGatewayClient.prototype.checkout = function (checkinId, roomId, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/order/checkout", { checkinId: checkinId, roomId: roomId }, token, 'put', { checkinId: checkinId, roomId: roomId });
    };
    /**
     * 检查是否需要支付押金(原checkin v1)
     * @param checkinId
     * @param token
     */
    XbedGatewayClient.prototype.queryCheckinStatus = function (checkinId, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/order/checkin", { checkinId: checkinId }, token, 'put', { checkinId: checkinId });
    };
    /**
     * 办理入住V2
     * @param checkinId 入住单号
     * @param token
     */
    XbedGatewayClient.prototype.checkin = function (checkinId, token, machineNumber) {
        if (machineNumber === void 0) { machineNumber = ''; }
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/order/checkinV2", { checkinId: checkinId, machineNumber: machineNumber }, token, 'put', { checkinId: checkinId, machineNumber: machineNumber });
    };
    /**
     * 判断是否可申请在住清洁
     * @param checkinId 入住单Id
     * @param orderNo 订单号
     * @param token
     */
    XbedGatewayClient.prototype.checkinClean = function (checkinId, orderNo, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/order/checkinClean", { checkinId: checkinId, orderNo: orderNo }, token);
    };
    /**
     * 提交在住清洁申请
     * @param checkinId 入住单详情
     * @param itemDetail 项目明细
     * @param orderNo 订单号
     * @param roomId 房间Id
     * @param time 时间Id
     * @param token
     */
    XbedGatewayClient.prototype.submitClean = function (checkinId, itemDetail, orderNo, roomId, time, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/order/clean", { checkinId: checkinId, itemDetail: itemDetail, orderNo: orderNo, roomId: roomId, time: time }, token);
    };
    /**
     * 取消在住清洁单
     * @param checkinId 入住单Id
     * @param orderNo 订单号
     * @param token
     */
    XbedGatewayClient.prototype.cancleCheckinClean = function (checkinId, orderNo, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/order/cancleCheckinClean", { checkinId: checkinId, orderNo: orderNo }, token);
    };
    /**
     * 提交清洁评价
     * @param checkinId 入住单id
     * @param cleanContent 清洁评价内容
     * @param cleanStarId 清洁评价星级
     * @param cleanTermIdList 清洁评价标签集合
     * @param content 评价内容（老版本）
     * @param mediaIdList 微信端传递
     * @param orderNo 订单号
     * @param roomContent 房间评价内容
     * @param roomId 房间Id
     * @param roomStarId 房间评价星级
     * @param roomTermIdList 房间评价标签集合
     * @param securityContent 安全感评价内容
     * @param securityStarId 安全感评价星级
     * @param securityTermIdList 安全感评价标签集合
     * @param starId 星Id
     * @param termIdList 标签Id列表(非必传)
     * @param token
     */
    XbedGatewayClient.prototype.submitCleanEvaluate = function (params, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/comment/cleanEvaluate", params, token);
    };
    /**
     * 远程开门
     * @param idCard 身份证后6位
     * @param roomId 房间Id
     * @param validVal 验证码
     * @param token
     */
    XbedGatewayClient.prototype.openDoor = function (idCard, roomId, validVal, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/lock/openDoor", { idCard: idCard, roomId: roomId, validVal: validVal }, token);
    };
    /**
     * 获取用户推广相关信息
     * @param token
     */
    XbedGatewayClient.prototype.userPopularizeInfo = function (token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/userPopularize/auth/info", {}, token);
    };
    /**
     * 保存用户推广相关信息
     * @param bankName 银行名称
     * @param bankNo 银行卡号
     * @param bankSignName 户名
     * @param phone 手机号
     * @param verifyCode 短信验证码
     * @param token
     */
    XbedGatewayClient.prototype.savePopularizeInfo = function (params, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/userPopularize/auth/save", params, token);
    };
    /**
     * 获取房间评价信息v4 evaluated：用户已评价返回评价内容信息 overdue：评价过期返回用户默认评价信息 waitEvaluate：未评价时返回评价参数
     * @param checkinId 入住单Id
     * @param roomId 房间Id
     * @param token
     */
    XbedGatewayClient.prototype.getRoomComment = function (checkinId, roomId, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/comment/v4/roomComment", { checkinId: checkinId, roomId: roomId }, token);
    };
    /**
     * 房间评价
     * @param checkinId 入住单id
     * @param cleanContent 清洁评价内容(新版本)
     * @param cleanStarId 清洁评价星级
     * @param cleanTermIdList 清洁评价标签集合
     * @param flag 标记是否返回评价数据
     * @param mediaIdList 微信端传递
     * @param roomContent 房间评价内容
     * @param roomStarId 房间评价星级
     * @param roomTermIdList 房间评价标签集合
     * @param securityContent 安全感评价内容
     * @param securityStarId 安全感评价星级
     * @param securityTermIdList 安全感评价标签集合
     * @param token
     */
    XbedGatewayClient.prototype.addRoomComment = function (params, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/v4/comment/addRoomComment", params, token);
    };
    /**
     * 是否可以重置超级密码
     * @param roomId 房间id
     * @param token
     */
    XbedGatewayClient.prototype.canResetPwd = function (roomId, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/lock/canResetPwd", { roomId: roomId }, token);
    };
    /**
     * 入住单密码重置
     * @param checkinId 入住单id
     * @param roomId 房间id
     * @param validVal 验证码
     * @param token
     */
    XbedGatewayClient.prototype.resetPwd = function (checkinId, roomId, validVal, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/checkin/resetPwd", { checkinId: checkinId, roomId: roomId, validVal: validVal }, token);
    };
    /**
     * 重置密码获取验证码
     * @param checkinId 入住单id
     * @param idCard 身份证后6位
     * @param isText true-文字短信；false-语音短信
     * @param token
     */
    XbedGatewayClient.prototype.getVerifyCodeForResetPwd = function (checkinId, idCard, isText, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/lock/resetPwd/getVerifyCode", { checkinId: checkinId, idCard: idCard, isText: isText }, token);
    };
    /**
     * 点击楼宇获取房间列表V4
     *
     * @param beginDate 入住时间
     * @param endDate 离店时间
     * @param buildingId 楼宇ID
     * @param isAvailableOnly 只看有房，默认0 （0 否，1是）
     * @param isImmediateCheckin 是否即时入住
     * @param rentType 1-短租；2-长租
     * @param token
     */
    XbedGatewayClient.prototype.getRoomsByBuilding = function (params) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/room/v4/getRoomsByBuilding", params);
    };
    /**
     * 模糊搜索多个子节点V4
     * @param city 城市
     * @param keyword 搜索关键字
     */
    XbedGatewayClient.prototype.searchMoreSubAllTag = function (city, keyword) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/v4/tagApi/searchMoreSubAllTag", { city: city, keyword: keyword });
    };
    /**
     * 删除入住人信息
     * @param id 入住人ID(checkinerId)
     * @param infoId 入住人信息ID
     * @param orderNo 订单
     * @param token
     */
    XbedGatewayClient.prototype.delCheckinPerson = function (id, infoId, orderNo, token) {
        return this.xbedClientPrepareRequest(this.gatewayUrl + "api/auth/userInfo/delCheckinPerson", { id: id, infoId: infoId, orderNo: orderNo }, token, 'delete', { id: id, infoId: infoId });
    };
    /**
     * 用户身份验证
     * @param token
     */
    XbedGatewayClient.prototype.getAuthentication = function (token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/order/authentication", {}, token);
    };
    /**
     * 根据token查询用户信息
     */
    XbedGatewayClient.prototype.findByToken = function (token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/user/findByToken", {}, token);
    };
    /**
     * 获取开门密码
     * @param checkinId 入住单Id
     */
    XbedGatewayClient.prototype.getOpenSecret = function (checkinId) {
        return this.prepareRequest(this.gatewayUrl + "api/auth/ownerOrder/checkin", {}, 'put', '', {
            checkinId: checkinId
        });
    };
    /**
     * 人脸开门
     * @param imageFace 上传的图片地址
     * @param roomId 房间id
     * @param type  1 微信 2 url
     * @param userId  用户ID
     */
    XbedGatewayClient.prototype.isFaceOpenDoor = function (handlerName, imageFace, roomId, type, userId) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/userInfo/faceOpenDoorV2", { handlerName: handlerName, imageFace: imageFace, roomId: roomId, type: type, userId: userId });
    };
    /**
     * 根据入住单ID查询扣款项详情
     * @param checkinId 入住单ID
     * @param token
     */
    XbedGatewayClient.prototype.queryRefundShortDetail = function (checkinId, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/app/refund/short/detail", { checkinId: checkinId }, token);
    };
    /**
     * 查询押金是否支付
     * @param checkinId 入住单ID
     */
    XbedGatewayClient.prototype.queryHasPayShortGuarentee = function (checkinId) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/order/hasPayShortGuarentee", { checkinId: checkinId }, '');
    };
    /**
     * 距离判断是否可以人脸或指纹开门
     * @param distance 	可以开门的距离
     * @param location  	用户经纬度
     * @param roomLocation 房间经纬度（入住单详情有）
     */
    XbedGatewayClient.prototype.queryIsOpenDoor = function (distance, location, roomLocation) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/userInfo/canOpenDoor", { distance: distance, location: location, roomLocation: roomLocation });
    };
    /**
     * 1、身份证验证 2、人脸识别验证
     *
     * @param frontImg 身份证正面图片
     * @param backImg 身份证背面图片
     * @param imageFace 人脸图片
     * @param imgType 图片获取方式 1、从微信的素材ID 2、七牛url
     * @param name 姓名
     * @param phone 电话
     * @param type 1、身份证 2、人脸
     * @param userId
     * @param token
     */
    XbedGatewayClient.prototype.queryIdCardAndFaceRecognition = function (params, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/userInfo/audit", params, token);
    };
    /**
     * 港澳台/外籍人士身份验证
     * @param certificateAuditStatus 证件审核状态
     * @param certificateIdNo 证件号
     * @param certificateValid 证有效日期
     * @param certificateType 证件类型
     * @param image1 证正面
     * @param image2 人脸正面
     * @param imageType 图片获取方式 1、从微信的素材ID 2、七牛url
     * @param name 姓名
     * @param userId
     * @param token
     */
    XbedGatewayClient.prototype.queryOtherCertificateRecognition = function (params, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api//userInfo/certificateAudit", params, token);
    };
    /**
     * 根据微信上传图片返回的serverId获得七牛图片地址
     * @param serverId 微信上传图片返回的serverId
     * @param token
     */
    XbedGatewayClient.prototype.wechatServerIdToQiNiuUrl = function (serverId, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/face/weChatToQiNiu", { serverId: serverId }, token);
    };
    /**
     * 根据手机号查询查询企业员工
     * @param mobile 	员工电话
     */
    XbedGatewayClient.prototype.queryIsEnterpriseEmployees = function (mobile) {
        return this.xbedClientGetRequest(this.gatewayUrl + "app/EnterpriseStaff/queryByMobile", { mobile: mobile }, '');
    };
    /**
     * 获取卡卷（活动）到期未读提醒数量
     */
    XbedGatewayClient.prototype.findCardCountByToken = function () {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/findCardCountByToken", {}, '');
    };
    /**
     * 更新卡卷（活动）未读状态
     * @param type 更新状态的类型 card卡券,activity活动,必传
     */
    XbedGatewayClient.prototype.updateActivityDoReaded = function (type) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/updateActivityOrCardDoReaded", { type: type }, '');
    };
    /**
     * 办理入住-寻求帮助 获取密码
     * @param checkinId 入住单ID
     */
    XbedGatewayClient.prototype.getCheckinRoomPassword = function (checkinId) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/checkin/getCheckinRoomPassword", { checkinId: checkinId }, '');
    };
    /**
     * 办理入住-寻求帮助 获取验证码
     */
    XbedGatewayClient.prototype.createOpenDoorCode = function () {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/identifyingCode/createOpenDoorCode", {});
    };
    /**
     * 远程开门
     * @param handlerName 手机号+订单号 mock phone_13797987456_order_43214123412
     * @param roomId 房价id
     */
    XbedGatewayClient.prototype.openRoomLock = function (handlerName, roomId, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/lock/openRoomLockV2.do", {
            handlerName: handlerName,
            roomId: roomId
        }, token);
    };
    /**
     * 使用用户 token 换取上传七牛的 token
     * @param source
     * @param isPrivate
     */
    XbedGatewayClient.prototype.getUploadToken = function (params, token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/material/getQiNiuToken", params, token);
    };
    /**
     * 七牛私有图片转换成可访问的地址
     * @param imgUrl 七牛私有地址
     * @param token
     */
    XbedGatewayClient.prototype.queryQiniuPrivateImageUrl = function (imgUrl, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/other/getPrivatePicUrl", { imgUrl: imgUrl }, token);
    };
    /**
     * 注册
     * @param phone 手机号码
     * @param source 注册来源
     */
    XbedGatewayClient.prototype.registerForLanding = function (phone, source) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/user/register", {
            phone: phone,
            source: source
        });
    };
    /**
     * 添加创客信息和签约意向对象
     * @param decorateLevel 装修等级0无1毛坯2简装3精装
     * @param email 电子邮箱
     * @param idCard 身份证号码
     * @param investIntention 投资意向0无1计划找房2现持有房源
     * @param name 姓名
     * @param oneBedroomNum 一居室数量
     * @param otherBedroomNum 其他数量
     * @param phone 手机号
     * @param propertyCity 物业城市
     * @param propertyDistrict 物业区域
     * @param propertyProvince 物业省份
     * @param residentCity 常驻城市
     * @param residentDistrict 常驻区域
     * @param residentProvince 常驻省份
     * @param threeBedroomNum 三居室数量
     * @param twoBedroomNum 二居室数量
     */
    XbedGatewayClient.prototype.addXbedMaker = function (params) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/XbUser/createMaker", params);
    };
    /**
     * 检查手机号码是否注册
     * @param phone 手机号码
     */
    XbedGatewayClient.prototype.isRegister = function (phone) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/user/isRegister", {
            phone: phone
        });
    };
    /**
     * 获取房客，房东文章列表
     * @param page 页码
     * @param pageSize 每页数据
     * @param type 文章类型，6 房东故事、7房客故事
     * @param terminal 平台类型  pc、ios、android、wechat
     */
    XbedGatewayClient.prototype.getArticle = function (page, pageSize, type, terminal) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/app/list_by_type", {
            page: page,
            pageSize: pageSize,
            type: type,
            terminal: terminal
        });
    };
    /**
     * 获取房间寻路指南位置信息(待支付订单列表)
     * @param rentType 租赁类型
     * @param roomId 房间id
     */
    XbedGatewayClient.prototype.getRoomNavigationInfo = function (rentType, roomId) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/room/v4/getRoomNavigationInfo", {
            rentType: rentType,
            roomId: roomId
        });
    };
    /**
     * 获取门店寻路指南位置信息(待支付订单列表)
     * @param rentType 租赁类型
     * @param roomTypeId 房型id
     */
    XbedGatewayClient.prototype.getChainNavigationInfo = function (rentType, roomTypeId) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/room/v4/getRoomNavigationInfo", {
            rentType: rentType,
            roomTypeId: roomTypeId
        });
    };
    /**
     * 办理入住校验身份（订单列表办理入住）
     * @param checkinId
     * @param roomId
     */
    XbedGatewayClient.prototype.checkLoginUserIdentity = function (checkinId, roomId) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/user/checkLoginUserIdentity", {
            checkinId: checkinId,
            roomId: roomId
        });
    };
    /**
     * 在首页查询是否跳转到订单列表页 或者 跳转到订单详情页
     */
    XbedGatewayClient.prototype.queryCheckinHomeList = function () {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/checkin/checkinHomeList", {});
    };
    /**
     * 七鱼客服系统后台 用户订单
     * @param phone  用户手机号
     * @param page  页码
     * @param size  每页显示的数量
     */
    XbedGatewayClient.prototype.getQiyuOrderList = function (phone, page, size) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/qiyu/checkin/qiyuCheckinList", {
            phone: phone,
            page: page,
            size: size
        });
    };
    /**
     * 无人入住酒店：二维码扫码次数更新
     * @param url 七牛私有地址
     * @param token
     */
    XbedGatewayClient.prototype.noOneQrCodeUpdate = function (url, params, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/oms/ruby/intelligentReception", __assign({ url: url }, params), token);
    };
    /**
     * 首页查询当天订单
     */
    XbedGatewayClient.prototype.queryNowOrder = function (token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/auth/checkin/homePageOrder", {}, token);
    };
    /**
     * 分页搜索门店
     * @param chainName:string;  门店名称(模糊搜索)
     * @param city:string; 门店所属城市
     * @param page:number;  	分页查询页码,默认为1
     * @param pageSize:number;  分页查询页大小,默认为10
     * @param province:string  门店所属省份
     */
    XbedGatewayClient.prototype.queryRoomInfo = function (params) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/roomInfo/chain/search", __assign({}, params));
    };
    /**
     * 搜索门店
     * @param chainName:string;  门店名称(模糊搜索)
     * @param city:string; 门店所属城市
     * @param province:string  门店所属省份
     */
    XbedGatewayClient.prototype.queryAllRoomInfo = function (params) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/roomInfo/chain/search/all", __assign({}, params));
    };
    /**
     * 获取百度活力验证access_token
     */
    XbedGatewayClient.prototype.getLivingAccessToken = function (token) {
        return this.xbedClientGetRequest(this.gatewayUrl + "api/tool-api", { url: '/api/face/getBaiduToken' }, token);
    };
    /**
     * 修改用户身份验证状态
     */
    XbedGatewayClient.prototype.modifyRegStatus = function (url, userId, state, idCheckResult, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/user-api", { url: url, userId: userId, state: state, idCheckResult: idCheckResult }, token);
    };
    /**
     * 退房开门接口
     * @param handlerName 开门原因(必填)
     * @param imageFace 人脸图片上传到七牛服务器后返回的url
     * @param latitude 	纬度(必填)
     * @param longitude 	经度(必填)
     * @param roomId 房间id(必填)
     * @param type 人脸开门的类型标记（1大陆身份证， 2港澳台）
     */
    XbedGatewayClient.prototype.overOpenDoor = function (handlerName, imageFace, latitude, longitude, roomId, type, token) {
        return this.xbedClientPostRequest(this.gatewayUrl + "api/auth/lock/easy-door/open-face", { handlerName: handlerName, imageFace: imageFace, latitude: latitude, longitude: longitude, roomId: roomId, type: type }, token);
    };
    // --------------------------------------------
    XbedGatewayClient.prototype.xbedClientGetRequest = function (url, queryParams, token) {
        if (token === void 0) { token = ''; }
        return this.xbedClientPrepareRequest(url, {}, token, 'get', queryParams);
    };
    XbedGatewayClient.prototype.xbedClientPostRequest = function (url, data, token) {
        if (token === void 0) { token = ''; }
        return this.xbedClientPrepareRequest(url, data, token, 'post');
    };
    /**
     * xbed client request
     *
     */
    XbedGatewayClient.prototype.xbedClientPrepareRequest = function (url, reqData, token, method, params) {
        if (token === void 0) { token = ''; }
        if (method === void 0) { method = 'post'; }
        if (params === void 0) { params = {}; }
        return this.prepareRequest(url, reqData, method, token ? token : this.token, params, {
            Edition: this.edition,
            Goods: this.goods,
            Terrace: this.terrace,
            'Xbed-Secret-Key': this.xbedSecretKey,
            'Xbed-Secret-Token': this.xbedSecretToken
        });
    };
    return XbedGatewayClient;
}(base_1.BaseClient));
exports.XbedGatewayClient = XbedGatewayClient;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/clients/xbed-gateway-client.js
// module id = 203
// module chunks = 44